import { fireEvent } from '@stitch-fix/kufak-gtm-client';

export const GTM_EVENT_TIMEOUT_MS = 1_000;

export type GtmEventDeliveryResult = 'acknowledged' | 'timed_out';

type SendGtmEventArgs = {
  eventName: string;
  eventAttributes: Record<string, unknown>;
  timeoutMs?: number;
};

/**
 * Sends an event and waits for GTM to acknowledge it or for the timeout to
 * expire. We use our own timer because GTM's `eventTimeout` calls
 * `eventCallback` in both cases, making a timeout look like an acknowledgement.
 */
export const sendGtmEvent = ({
  eventName,
  eventAttributes,
  timeoutMs = GTM_EVENT_TIMEOUT_MS,
}: SendGtmEventArgs): Promise<GtmEventDeliveryResult> =>
  new Promise((resolve, reject) => {
    let settled = false;

    const handleCallback = (result: GtmEventDeliveryResult) => {
      if (settled) return;

      settled = true;
      clearTimeout(timeoutId);
      resolve(result);
    };

    const timeoutId = window.setTimeout(
      () => handleCallback('timed_out'),
      timeoutMs,
    );

    try {
      fireEvent({
        eventName,
        eventAttributes: {
          ...eventAttributes,
          eventCallback: () => handleCallback('acknowledged'),
        },
      });
    } catch (error) {
      clearTimeout(timeoutId);
      reject(error);
    }
  });
